<template>
  <div class="container pt-0">
    <div class="title has-text-centered">{{ $t("my classrooms") }}</div>
    <div class="columns">
      <div class="column is-3">
        <generic-dropdown
          :title="$t('period')"
          :placeholder="$t('period')"
          url="/student/period/catalog"
          name_field="name"
          value_field="period_id"
          @selected="set_period"
          ref="period_dropdown"
          :is_multiple="false"
          class="mb-3"
        />
        <classroom-list
          ref="classroom_list"
          @classroom_selected="classroom_selected"
          @classroom_updated="classroom_updated"
          @classrooms_loaded="classrooms_loaded"
        />
        <!-- <div
          class="button is-primary mt-3"
          @click="new_classroom"
          v-show="selected_period"
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("new classroom") }}</span>
        </div> -->
      </div>
      <div class="column">
        <classroom-detail
          ref="classroom_detail"
          @edit_classroom="edit_classroom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import ClassroomList from "./my_classrooms/ClassroomList.vue";
import ClassroomDetail from "./my_classrooms/ClassroomDetail.vue";

export default {
  name: "ProfessorMyClassrooms",
  components: { GenericDropdown, ClassroomList, ClassroomDetail },
  data() {
    return {
      is_loading: false,
      selected_period: null,
    };
  },
  methods: {
    set_period(period) {
      this.selected_period = period;
      this.$refs.classroom_list.get_classrooms(period);
    },
    new_classroom() {
      this.$refs.classroom_list.new_classroom(this.selected_period);
    },
    classroom_selected(classroom) {
      this.$refs.classroom_detail.set_classroom(classroom);
    },
    edit_classroom(classroom) {
      this.$refs.classroom_list.edit_classroom(classroom);
    },
    classroom_updated() {
      this.$refs.classroom_detail.refresh();
    },
    classrooms_loaded() {
      this.$refs.classroom_detail.clear();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
